import { Component, OnInit } from '@angular/core';
import { Router ,NavigationEnd, ActivatedRoute } from '@angular/router';
import { AuthService } from './auth/auth.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent{
  title = 'app';
  
  hideNav = false;

  constructor( private router: Router, private activatedRoute: ActivatedRoute) {
    
  }

  ngOnInit(){
    this.navHidden();
  }

  navHidden(){
    this.router.events.subscribe((val) => {
      // see also  
      // console.log(val instanceof NavigationEnd);
      // console.log(val);  
      // this.routeUrl = NavigationEnd
      if(this.router.routerState.snapshot.url == '/marketing' || this.router.routerState.snapshot.url == '/marketing/marketing-dashboard' ||this.router.routerState.snapshot.url == '/marketing/search-jobs' || this.router.routerState.snapshot.url == '/marketing/search-candidate' ){
     //   console.log("yes its markting");
        this.hideNav = true;
      }
     // console.log(this.router.routerState.snapshot.url)
  });
  }
}
